import { Popover } from "@InnoUI/";
import { apiGet } from "api/callApi";
import TooltipText from "components/TooltipText";
import InnoIcons from "InnoUI/innoicons";
import { useEffect, useState } from "react";
import theme from "theme";

const ViewRole = (props) => {
  const { folder } = props;
  const [permissionData, setPermissionData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getPermission();
  }, [folder]);

  useEffect(() => {
    setPermissionData(false);
    setOpenModal(false);
  }, []);

  const getPermission = async () => {
    try {
      const response = await apiGet(
        `/v1/folderpermissions/${folder.id}`,
        false,
      );
      setPermissionData(response.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        {permissionData?.readRoles?.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              marginRight: "10px",
            }}
          >
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <span>
                      <InnoIcons.VisibilityIcon
                        sx={{
                          fontSize: "14px",
                          margin: "5px 3px -2px 10px",
                          color: theme.colors.themeColor,
                        }}
                      />
                    </span>
                    <TooltipText
                      title={permissionData.readRoles
                        .map((item) => item.name)
                        .join(", ")}
                      maxLength={50}
                      style={{ fontSize: "14px" }}
                    />
                  </div>
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {permissionData.readRoles
                          .map((item) => item.name)
                          .join(", ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          </div>
        )}
        {permissionData?.writeRoles?.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <span>
                      <InnoIcons.EditIcon
                        sx={{
                          fontSize: "14px",
                          margin: "5px 3px -2px 10px",
                          color: theme.colors.themeColor,
                        }}
                      />
                    </span>

                    <TooltipText
                      title={permissionData.writeRoles
                        .map((item) => item.name)
                        .join(", ")}
                      maxLength={50}
                      style={{ fontSize: "14px" }}
                    />
                  </div>
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {permissionData.writeRoles
                          .map((item) => item.name)
                          .join(", ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ViewRole;
